import React, { useState, useEffect } from "react";
import "./ProductDetails.css";
import BaseButton from "../Common/BaseButton";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const ProductAbout = ({ productabout ,handleProductRegenerate, loading, handleManualEdit, onHide, sectionId, sectionTitle, isHidden, onUnhide}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [aboutText, setAboutText] = useState(productabout);
  const [previousResponse, setPreviousResponse] = useState(productabout || "");
  
  // Update previous response when aboutText changes
  useEffect(() => {
    if (aboutText && aboutText.trim() !== "") {
      setPreviousResponse(aboutText);
    }
  }, [aboutText]);
  
  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleDoneClick = () => {
    setIsEditing(false);
    handleManualEdit("teaser", aboutText);
  };

  const handleTextChange = (e) => {
    setAboutText(e.target.value);
  };
  
  const handleRegenerate = async (type, formData, aboutText) => {
    let furtherDetailsToSend = "";
    let customPromptToSend = null;

    if (typeof formData === "object" && formData !== null) {
      // If reason is present, send it as furtherDetails
      if (formData.reason && formData.reason.trim() !== "") {
        furtherDetailsToSend = formData.reason;
      } else {
        // If no reason, but goal/role/constraints are present, send them as customPrompt
        customPromptToSend = {
          goal: formData.goal,
          role: formData.role,
          constraints: formData.constraints,
        };
      }
    } else if (typeof formData === "string") {
      // If only a string is passed, treat it as reason
      furtherDetailsToSend = formData;
    }

    // Pass the previous response to the regenerate function
    await handleProductRegenerate(type, furtherDetailsToSend, aboutText, customPromptToSend, previousResponse);
  };
  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">About the Product</div>
       <div className="button-group">
          {isEditing ? (
            <BaseButton className="dark btn btn-dark" children="Done"  handleClick={handleDoneClick} />
          ) : (
            <>
              <BaseButton
                className="outlineprimary"
                children="Regenerate Text"
                imageSrc="/regenerate-text.svg"
                isModalOpen={true}
                handleClick={(formData) => handleRegenerate("teaser", formData, aboutText)}
              />
              {isHidden && onUnhide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Unhide Section"
                  handleClick={onUnhide}
                />
              ) : onHide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Hide Section"
                  handleClick={() => onHide(sectionId, sectionTitle)}
                />
              ) : null}
              <BaseButton className="outlineprimary" children="Edit Text" imageSrc="/edit-text.svg" handleClick={handleEditClick} />
            </>
          )}
        </div>
        
      </div>
      {loading ? (
        // Skeleton loader for three lines
        <div>
          <Skeleton height={12} width="90%" style={{ marginBottom: 5 }} />
          <Skeleton height={12} width="85%" style={{ marginBottom: 5 }} />
          <Skeleton height={12} width="80%"  />
        </div>
      ) : isEditing ? (
        <textarea
          className="product-description-input form-control"
          value={aboutText}
          onChange={handleTextChange}
        />
      ) : (
        <p className="product-description aboutSection">{aboutText}</p>
      )}
    </div>
  );
};

export default ProductAbout;
